import { Link } from 'react-router-dom';
import { useJobs } from '../hooks/useJobs';

const Dashboard = () => {
  const { jobs, loading } = useJobs('active');

  const getStatusBadge = (status) => {
    const map = { active: 'bg-success', completed: 'bg-secondary', cancelled: 'bg-danger' };
    return map[status] || 'bg-secondary';
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h1 className="mb-1">Dashboard</h1>
          <p className="text-muted">AE Conrad Co. Inventory Management System</p>
        </div>
      </div>

      <div className="row g-4">
        <div className="col-md-8">
          <div className="card shadow-sm">
            <div className="card-header bg-white">
              <h5 className="card-title mb-0">Quick Actions</h5>
            </div>
            <div className="card-body">
              <div className="row g-3">
                <div className="col-md-6">
                  <Link to="/inventory/add" className="btn btn-success w-100 btn-lg">
                    <i className="bi bi-plus-circle me-2"></i>
                    Add Inventory
                  </Link>
                </div>
                <div className="col-md-6">
                  <Link to="/inventory/remove" className="btn btn-danger w-100 btn-lg">
                    <i className="bi bi-dash-circle me-2"></i>
                    Remove Inventory
                  </Link>
                </div>
                <div className="col-md-6">
                  <Link to="/jobs" className="btn btn-outline-primary w-100">
                    <i className="bi bi-briefcase me-2"></i>
                    Manage Jobs
                  </Link>
                </div>
                <div className="col-md-6">
                  <Link to="/transactions" className="btn btn-outline-primary w-100">
                    <i className="bi bi-journal-text me-2"></i>
                    View Ledger
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-4">
          <div className="card shadow-sm">
            <div className="card-header bg-white">
              <h5 className="card-title mb-0">About FIFO</h5>
            </div>
            <div className="card-body">
              <p className="small mb-2">
                <strong>First-In, First-Out (FIFO)</strong> inventory costing ensures:
              </p>
              <ul className="small mb-0">
                <li>Oldest inventory is used first</li>
                <li>Accurate cost tracking by lot</li>
                <li>Proper valuation of remaining stock</li>
                <li>Complete transaction history</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="row mt-4">
        <div className="col-12">
          <div className="card shadow-sm">
            <div className="card-header bg-white d-flex justify-content-between align-items-center">
              <h5 className="card-title mb-0">Active Jobs</h5>
              <Link to="/jobs" className="btn btn-sm btn-outline-primary">Manage Jobs</Link>
            </div>
            <div className="card-body p-0">
              {jobs.length === 0 ? (
                <p className="text-muted p-3 mb-0">No active jobs.</p>
              ) : (
                <div className="table-responsive">
                  <table className="table table-hover table-sm mb-0">
                    <thead>
                      <tr>
                        <th>Job #</th>
                        <th>Name</th>
                        <th>Status</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {jobs.map(job => (
                        <tr key={job.id}>
                          <td><strong>{job.job_number}</strong></td>
                          <td>{job.name}</td>
                          <td>
                            <span className={`badge ${getStatusBadge(job.status)}`}>
                              {job.status.charAt(0).toUpperCase() + job.status.slice(1)}
                            </span>
                          </td>
                          <td className="text-end">
                            <Link
                              to={`/transactions?job_id=${job.id}`}
                              className="btn btn-sm btn-outline-secondary me-1"
                            >
                              <i className="bi bi-journal-text me-1"></i>Ledger
                            </Link>
                            <Link
                              to={`/inventory/add?job_id=${job.id}`}
                              className="btn btn-sm btn-outline-success me-1"
                            >
                              <i className="bi bi-arrow-return-left me-1"></i>Return Items
                            </Link>
                            <Link
                              to={`/inventory/remove?job_id=${job.id}`}
                              className="btn btn-sm btn-outline-danger"
                            >
                              <i className="bi bi-dash-circle me-1"></i>Allocate Items
                            </Link>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
